module.exports = __webpack_public_path__ + "img/logo.aa228ea0.svg";